import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  RegisterSignUpStepFormSchema,
  RegisterSignUpStepMutation,
} from './RegisterSignUpStepForm.types';
import { getRegisterSignUpStepForm } from './RegisterSignUpStepForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import {
  REGISTER_SIGN_UP_QUERY_KEY,
  registerSignUpENTQuery,
  registerSignUpProspectENTQuery,
  registerSignUpQuery,
} from './RegisterSignUpStepForm.query';
import Form from '../../../../../commons/Form/Form';
import { registerSignUpStepData } from './RegisterSignUpStepForm.data';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { User, UserRoles } from '../../../../../../types/models/user/user.types';
import { getStepIdFromPUBStep } from '../../../../../../utils/helpers/user/getStep';
import { RegisterStepsList } from '../../RegisterSteps.types';
import moment from 'moment';
import { api } from '../../../../../../utils/api/api';
import { setProfile } from '../../../../../../store/authentication/authenticationActions/authenticationActions';
import { useCallback, useEffect, useMemo } from 'react';
import { usePendingProspect } from '../../../../../../hooks/fetchers/usePendingProspect/usePendingProspect';
import Loading from '../../../../../commons/Loading/Loading';

export default () => {
  const { role } = useParams();
  const [searchParams] = useSearchParams();

  const [referrer, pid] = useMemo(
    () => [searchParams.get('referrer'), searchParams.get('pid')],
    [searchParams]
  );

  // const [referrer, user, hash] = useMemo(
  //   () => [searchParams.get('referrer'), searchParams.get('user'), searchParams.get('hash')],
  //   [searchParams]
  // );

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [, setCookie] = useCookies(['token']);

  // @ts-ignore // isInitialLoading isn't recongnized by Typescript but exists
  const { data: pendingProspect, refetch: refetchPendingProspect, isInitialLoading } = usePendingProspect(
    {
      referrerId: parseInt(referrer || ''),
      prospectId: parseInt(pid || '')
    },
    {
      enabled: Boolean(referrer && pid),
    }
  );

  const formProps = useForm<RegisterSignUpStepFormSchema>({
    resolver: yupResolver(getRegisterSignUpStepForm),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit, setValue } = formProps;

  useEffect(() => {
    if (referrer && pid) {
      refetchPendingProspect
    }
  }, [])

  useEffect(() => {
    if (pendingProspect) {
      setValue('email', pendingProspect.email, { shouldValidate: true });
    }
  }, [pendingProspect]);

  const currentMutation = useCallback(
    (data: RegisterSignUpStepFormSchema) => {
      if (referrer && pid) {
        return registerSignUpProspectENTQuery({ ...data, referrer: parseInt(referrer) });
      }
      switch (role) {
        case UserRoles.Entreprise:
          return registerSignUpENTQuery(data);
        case UserRoles.AcheteurPublic:
          return registerSignUpQuery({ ...data, role: (role as UserRoles) || 'PUB' });
        default:
          return registerSignUpQuery({ ...data, role: (role as UserRoles) || 'PUB' });
      }
    },
    [role, referrer, pid]
  );

  const { mutate } = useMutation<
    Awaited<ReturnType<RegisterSignUpStepMutation>>,
    Error,
    RegisterSignUpStepFormSchema
  >((data) => currentMutation(data), {
    mutationKey: REGISTER_SIGN_UP_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: ({ accessToken, user }) => {
      api.setHeader('authorization', `Bearer ${accessToken}`);
      setCookie('token', accessToken, {
        expires: moment().add(60, 'minutes').toDate(),
        path: '/',
      });
      setProfile({ ...(user as User), id_step: getStepIdFromPUBStep(RegisterStepsList.SignUp) })(
        dispatch
      );
      // navigate('/register/PUB/step/entity')
    },
    onError: async (error) => alert(error.message),
  });

  const onSubmit = handleSubmit((data) => mutate(data));

  if (isInitialLoading) return <Loading />;

  return (
    <>
      <Form<RegisterSignUpStepFormSchema>
        data={registerSignUpStepData}
        {...{ formProps, onSubmit }}
        isCompany={role === UserRoles.Entreprise}
      />
    </>
  );
};
